export default `
  query listSubscriptions {
    listSubscriptions {
      email
      createdAt
      updatedAt
      enterpriseCustomerId
      payerUser {
        id
        email
        firstname
        lastname
        stripeCustomerId
      }
      feedback
    }
  }
`
